module.exports = __webpack_public_path__ + "static/media/user-mobi-icon.d56edfa8.svg";